export default __webpack_public_path__ + "static/media/off_label.fcf98998.svg";